/* Lokikirja: lite embed. YouTube-iframe luodaan vasta klikkauksesta
   (Core Web Vitals). Lukujen ja tuotteiden aikaleimalinkit kayttavat samaa
   soitinta: data-lk-seek="252" -> iframe alkaa siita kohdasta. Ilman
   JavaScriptia linkit vievat YouTubeen oikeaan kohtaan (href ...&t=252s). */
(function () {
  function load(player, start) {
    var id = player.getAttribute('data-yt');
    if (!id) return;
    var src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
      '?autoplay=1&rel=0&cc_load_policy=1' + (start ? '&start=' + start : '');
    var frame = player.querySelector('iframe');
    if (!frame) {
      frame = document.createElement('iframe');
      frame.setAttribute('title', player.getAttribute('aria-label') || 'YouTube');
      frame.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      frame.setAttribute('allowfullscreen', '');
      var wrap = document.createElement('div');
      wrap.className = player.className;
      wrap.setAttribute('data-yt', id);
      wrap.appendChild(frame);
      player.replaceWith(wrap);
    }
    frame.src = src;
  }

  // Tuotesivun "Nahty Lokikirjassa" -linkki: #t=252 -> toisto alkaa siita.
  var hashStart = (location.hash.match(/^#t=(\d+)$/) || [])[1];

  document.addEventListener('click', function (e) {
    var player = e.target.closest('button.lk-player[data-yt]');
    if (player) { load(player, hashStart ? parseInt(hashStart, 10) : 0); return; }
    var seek = e.target.closest('[data-lk-seek]');
    if (!seek) return;
    var target = document.querySelector('.lk-player[data-yt]');
    if (!target) return;
    e.preventDefault();
    load(target, parseInt(seek.getAttribute('data-lk-seek'), 10) || 0);
    target = document.querySelector('.lk-player[data-yt]');
    if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();
